﻿<script setup lang="ts">

    import { AttributeValue } from '@/shared/codeedit/codeEditFields.ts';
    import useCopyToClipboard from '@/shared/composables/useCopyToClipboard';

    const copyToClipBoard = useCopyToClipboard();
    const props = defineProps<{
        label: string;
        value?: AttributeValue;
    }>();
</script>

<template>
    <b-field
        horizontal
        :label="props.label">
        <div class="is-flex is-justify-content-space-between is-gap-1">
            <div class="is-flex-grow-1">
                <b-input
                    :model-value="props.value"
                    disabled />
            </div>
            <div class="is-flex-1">
                <slot name="unit" />
            </div>
            <b-tooltip
                class="control"
                :label="'Copy value'"
                position="is-top">
                <b-button
                    :disabled="!props.value"
                    @click="copyToClipBoard.copyTextToClipboard(props.value ? props.value.toString() : '')">
                    <b-icon
                        icon="content-copy"
                        size="is-small" />
                </b-button>
            </b-tooltip>
        </div>
    </b-field>
</template>

<style scoped>

</style>
